function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFaq = function SvgFaq(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 26"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.8 19.7V18H11v1.6zm1.1-5.6c-.4.7-.6 1.4-.8 2.2h-1.2v-2.7l.9-1.9c.2-.4.1-.9-.3-1.1s-.9 0-1.1.4l-.4.8-.7-.9c-.2-.4-.7-.5-1.1-.2s-.4.8-.2 1.2l1.3 1.9v2.7h-1.5c-.1-.7-.4-1.4-.7-2.1l-.8-1.7c-1.4-2.9.6-6.3 3.7-6.3 3.2 0 5.3 3.6 3.7 6.4zM13 4.7c-4.3 0-7.1 4.7-5.2 8.7l.9 1.7c.5 1 .7 2.1.7 3.2v1.5c0 .9.7 1.6 1.6 1.6h4c.8 0 1.4-.7 1.4-1.5v-1.5c0-1.2.4-2.4.9-3.4l.8-1.4c2.2-4-.6-8.9-5.1-8.9",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgFaq;